export default __webpack_public_path__ + "static/media/assign.32682595.png";